module.exports = __webpack_public_path__ + "img/IMG_20191015_215001.cda49701.webp";